/**
 * 通用进度条组件
 * 支持自定义颜色、文本显示
 */

import { FC } from 'react';
import type { ProgressBarProps } from './types';

export const ProgressBar: FC<ProgressBarProps> = ({
  progress,
  text,
  completedColor = '#10B981', // 默认绿色（Figma 500 11-fill-常规）
  remainingColor = '#E2E2E2', // 默认浅灰色（根据 Figma）
  showText = true,
  className = '',
  textPosition = 'right',
}) => {
  // 确保进度值在 0-100 范围内
  const clampedProgress = Math.min(Math.max(progress, 0), 100);

  const getTextPositionClass = () => {
    switch (textPosition) {
      case 'left':
        return 'flex-row-reverse';
      case 'center':
        return 'justify-center';
      default:
        return '';
    }
  };

  return (
    <div className={`w-full flex items-center gap-[8px] ${getTextPositionClass()} ${className}`}>
      {/* 进度条容器 */}
      <div className="w-full h-[8px] rounded-full overflow-hidden" style={{ backgroundColor: remainingColor }}>
        <div
          className="h-full transition-all duration-300 ease-out rounded-full"
          style={{
            width: `${clampedProgress}%`,
            backgroundColor: completedColor,
          }}
        />
      </div>

      {/* 进度文本 */}
      {showText && text && <span className="text-[12px] text-[#737373] whitespace-nowrap flex-shrink-0">{text}</span>}
    </div>
  );
};
